// XSM-1536 - SSO Feature
// Author: Abhishek Bharti
import {
  EVES_SUB_SYS_DOMAIN,
  EVES_SYS_DOMAIN,
  MASTER_CALLBACK_URL,
  MASTER_CLIENT_KEY,
  MASTER_CLIENT_SECRET,
  MASTER_DOMAIN,
  MASTER_SUB_DOMAIN,
  PARTNER_CALLBACK_URL,
  PARTNER_CLIENT_KEY,
  PARTNER_CLIENT_SECRET,
  PARTNER_DOMAIN,
  PARTNER_SUB_DOMAIN,
  SYS_ADMIN_CALLBACK_URL,
  SYS_ADMIN_CLIENT_KEY,
  SYS_ADMIN_CLIENT_SECRET,
  COMMON_CLIENT_KEY,
  COMMON_CLIENT_SECRET,
  COMMON_CALLBACK_URL,
  COMMON_DOMAIN,
  COMMON_SUB_DOMAIN
} from ".";

const subDomainClientMapping = (subDomain: string) => {
  switch (subDomain) {
    case MASTER_SUB_DOMAIN:
      return {
        domain: MASTER_DOMAIN,
        clientId: MASTER_CLIENT_KEY,
        clientSecret: MASTER_CLIENT_SECRET,
        redirectURL: MASTER_CALLBACK_URL
      };
    case PARTNER_SUB_DOMAIN:
      return {
        domain: PARTNER_DOMAIN,
        clientId: PARTNER_CLIENT_KEY,
        clientSecret: PARTNER_CLIENT_SECRET,
        redirectURL: PARTNER_CALLBACK_URL
      };
    case EVES_SUB_SYS_DOMAIN:
      return {
        domain: EVES_SYS_DOMAIN,
        clientId: SYS_ADMIN_CLIENT_KEY,
        clientSecret: SYS_ADMIN_CLIENT_SECRET,
        redirectURL: SYS_ADMIN_CALLBACK_URL
      };
    case COMMON_SUB_DOMAIN:
      return {
        domain: COMMON_DOMAIN,
        clientId: COMMON_CLIENT_KEY,
        clientSecret: COMMON_CLIENT_SECRET,
        redirectURL: COMMON_CALLBACK_URL
      };
    default:
      return {
        domain: COMMON_DOMAIN,
        clientId: COMMON_CLIENT_KEY,
        clientSecret: COMMON_CLIENT_SECRET,
        redirectURL: COMMON_CALLBACK_URL
      };
  }
};

export default subDomainClientMapping;
